/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateMeetingTypeDto } from '../models/work-create-meeting-type-dto';
import { WorkMeetingType } from '../models/work-meeting-type';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateMeetingTypeDto } from '../models/work-update-meeting-type-dto';

@Injectable({ providedIn: 'root' })
export class WorkMeetingTypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `meetingTypesV2ControllerFindAllPaginated()` */
  static readonly MeetingTypesV2ControllerFindAllPaginatedPath = '/v2/meeting-types';

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTypesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTypesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> title:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>title</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'title:ASC' | 'title:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingType>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTypesV2Service.MeetingTypesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkMeetingType>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTypesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTypesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> title:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>title</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'title:ASC' | 'title:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingType>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}> {
    return this.meetingTypesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingType>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingType>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `meetingTypesV2ControllerCreate()` */
  static readonly MeetingTypesV2ControllerCreatePath = '/v2/meeting-types';

  /**
   * Required permissions: meeting-types:create, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTypesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTypesV2ControllerCreate$Response(
    params: {
      body: WorkCreateMeetingTypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingType>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTypesV2Service.MeetingTypesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingType>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:create, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTypesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTypesV2ControllerCreate(
    params: {
      body: WorkCreateMeetingTypeDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingType> {
    return this.meetingTypesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingType>): WorkMeetingType => r.body)
    );
  }

  /** Path part for operation `meetingTypesV2ControllerFindAll()` */
  static readonly MeetingTypesV2ControllerFindAllPath = '/v2/meeting-types/all';

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTypesV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTypesV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkMeetingType>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTypesV2Service.MeetingTypesV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkMeetingType>>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTypesV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTypesV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkMeetingType>> {
    return this.meetingTypesV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkMeetingType>>): Array<WorkMeetingType> => r.body)
    );
  }

  /** Path part for operation `meetingTypesV2ControllerFindOneById()` */
  static readonly MeetingTypesV2ControllerFindOneByIdPath = '/v2/meeting-types/{id}';

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTypesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTypesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingType>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTypesV2Service.MeetingTypesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingType>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTypesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTypesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeetingType> {
    return this.meetingTypesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingType>): WorkMeetingType => r.body)
    );
  }

  /** Path part for operation `meetingTypesV2ControllerDelete()` */
  static readonly MeetingTypesV2ControllerDeletePath = '/v2/meeting-types/{id}';

  /**
   * Required permissions: meeting-types:delete, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTypesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTypesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingType>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTypesV2Service.MeetingTypesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingType>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:delete, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTypesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTypesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeetingType> {
    return this.meetingTypesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingType>): WorkMeetingType => r.body)
    );
  }

  /** Path part for operation `meetingTypesV2ControllerUpdate()` */
  static readonly MeetingTypesV2ControllerUpdatePath = '/v2/meeting-types/{id}';

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTypesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTypesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateMeetingTypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingType>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTypesV2Service.MeetingTypesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingType>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTypesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTypesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateMeetingTypeDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingType> {
    return this.meetingTypesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingType>): WorkMeetingType => r.body)
    );
  }

}
